import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "../Hooks/useFetch";
import { judgesURL } from "../Hooks/URL";
import { userContext } from "../Contexts/userContext";
import Judges from "../Templates/Home/Judges/Judges";

function JudgesPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Filter, setFilter] = useState("");
  const [Open, setOpen] = useState(false);

  const [judges, setJudges] = useState([]);
  const { data, loading, error } = useFetch(
    judgesURL,
    page,
    rowsPerPage,
    search,
    null,
    null,
    Filter
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setJudges(data.data);
      setPageCount(data.pagesCount);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "judges", data: "" });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Judges
      role={contextData?.role}
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      judges={judges}
      navigate={navigate}
      handleChangePage={handleChangePage}
      Open={Open}
      setOpen={setOpen}
      loading={loading}
      data={data}
      error={error}
      pageCount={pageCount}
      setJudges={setJudges}
      setFilter={setFilter}
    />
  );
}

export default JudgesPage;
